import type { ComponentType } from 'react';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';

/** Fixed body height — rows scroll inside the grid (not page growth). */
export const INDEXER_AG_GRID_HEIGHT = '480px';

/** Fill parent flex/offcanvas/modal body (parent must have a definite height). */
export const INDEXER_AG_GRID_FILL_HEIGHT = '100%';

type AgGridWrapperProps = {
  table_name?: string;
  height?: string;
  columns: unknown[];
  data: unknown[];
  total?: number;
  hideFooter?: boolean;
  hideExportHelpAlert?: boolean;
  settings?: Record<string, unknown>;
  otherOptions?: Record<string, unknown>;
};

const TypedAgGridWrapper = AgGridWrapper as ComponentType<AgGridWrapperProps>;

const DEFAULT_SETTINGS = {
  pagination: false,
  fullscreen: false,
  changeHeight: false,
  saveGrid: false,
  resetGrid: false,
  sideBar: false,
  exportBtn: false,
  export: { enabled: false },
};

/** Client-side AG Grid for Indexer tables (no pagination chrome). */
export function IndexerAgGrid({
  tableName,
  columns,
  data,
  height = INDEXER_AG_GRID_HEIGHT,
  otherOptions,
}: {
  tableName: string;
  columns: unknown[];
  data: unknown[];
  height?: string;
  otherOptions?: Record<string, unknown>;
}) {
  return (
    <TypedAgGridWrapper
      key={height}
      table_name={tableName}
      height={height}
      columns={columns}
      data={data}
      total={data.length}
      hideFooter
      hideExportHelpAlert
      settings={DEFAULT_SETTINGS}
      otherOptions={{ ...otherOptions, pagination: false }}
    />
  );
}
